import type { LocaleStrings } from "../types.ts";

export const deLocale: LocaleStrings = {
  game: {
    defaultClanName: "Dein Clan",
    clanSetupTitle: "Gründe deinen Clan",
    clanSetupNameLabel: "Clanname",
    clanSetupNamePlaceholder: "Namen eingeben",
    clanSetupConfirm: "Bestätigen",
    settleConfirm: "Fortsetzen",
    promptConfirmStart: "Hier starten?",
    startTileConfirm: "Bestätigen",
    startTileCancel: "Abbrechen",
    clanSetupTotemLabel: "Totem",
    promptClanSetup: "Benenne deinen Clan, wähle ein Totem und bestätige, um eine Startkachel zu wählen.",
    statsHeaderFormat: "{clanName} · {turnLabel} {turn}",
    promptSelectStart: "Wähle, wo dein Clan beginnen soll.",
    promptClanEstablished: "Clan gegründet.",
    promptEndTurn: "Beende deinen Zug, wenn du bereit bist.",
    promptNewTurn: "Wechsle auf eine angrenzende Kachel oder beende deinen Zug.",
    promptVictory: "Dein Clan gedeiht!",
    promptDefeat: "Dein Clan hungert.",
    tileContentsFormat: "{terrain} — {food} Nahrung/Zug",
    tileContentsReducedFormat: "{terrain} — {effective}/{base} Nahrung/Zug",
    tileTravelingFormat: "{terrain} — unterwegs, keine Ernte in diesem Zug",
    turnLabel: "Zug",
    dayNightLabels: {
      day: "Tag",
      dusk: "Dämmerung",
      night: "Nacht",
      dawn: "Morgendämmerung",
    },
    seasonLabels: {
      spring: "Frühling",
      summer: "Sommer",
      autumn: "Herbst",
      winter: "Winter",
    },
    temperatureFormat: "{value}°C",
    weatherLabels: {
      clear: "Klar",
      cloudy: "Bewölkt",
      overcast: "Bedeckt",
      rainy: "Regen",
      snowy: "Schnee",
    },
    populationLabel: "Bevölkerung",
    foodLabel: "Nahrung",
    waterLabel: "Wasser",
    ambientPredatorsLabel: "Raubtiere",
    ambientPredatorLevelLabels: {
      none: "Keine",
      low: "Niedrig",
      medium: "Mittel",
      high: "Hoch",
    },
    populationProgressFormat: "{current} / {max}",
    foodGrowthHintFormat: "→ Wachstum bei {threshold}",
    statsCollapsedChipFormat: "Zug {turn} · {population} · {food} · {water} · {predators}",
    endTurnLabel: "Zug beenden",
    terrainNames: {
      ["desert"]: "Wüste",
      ["mountain"]: "Gebirge",
      ["swamp"]: "Sumpf",
      ["forest"]: "Wald",
      ["plains"]: "Ebene",
      ["river"]: "Fluss",
    },
    totemNames: {
      carved: "Geschnitzt",
      antler: "Geweih",
      spiral: "Spirale",
    },
    victoryTitle: "Sieg!",
    victoryMessage: "Dein Clan hat 30 Menschen erreicht. Eine echte Zivilisation beginnt.",
    victoryRecapLineFormat: "{label}: {value}",
    victoryRecapTurns: "Züge bis zum Sieg",
    victoryRecapPopulation: "Bevölkerung",
    victoryRecapFood: "Nahrung",
    victoryRecapStartTerrain: "Startgelände",
    victoryRecapEndTerrain: "Endgelände",
    victoryRecapExplored: "Karte erkundet",
    victoryRecapExploredFormat: "{explored} / {total} Felder",
    defeatTitle: "Niederlage",
    defeatMessage: "Die letzten deines Volkes sind verschwunden.",
    startAgain: "Neu starten",
    resetLabel: "Zurücksetzen",
    exitGame: "Spiel verlassen",
    settingsTitle: "Einstellungen",
    settingsCloseAriaLabel: "Einstellungen schließen",
    languageLabel: "Sprache",
    sfxVolumeLabel: "Soundeffekte — {level}",
    debugModeOff: "Debug-Modus aus",
    debugModeOn: "Debug-Modus an",
    fullscreenOff: "Vollbild aus",
    fullscreenOn: "Vollbild an",
    foodOverlayOff: "Nahrung auf der Karte anzeigen",
    foodOverlayOn: "Nahrung auf der Karte ausblenden",
    waterOverlayOff: "Wasser auf der Karte anzeigen",
    waterOverlayOn: "Wasser auf der Karte ausblenden",
    promptBannerHide: "Hinweisbanner ausblenden",
    promptBannerShow: "Hinweisbanner anzeigen",
    stagingBadgeLabel: "Staging",
    hudSettingsTooltip: "Einstellungen öffnen",
    hudNotificationsTooltip: "Benachrichtigungen öffnen",
    notificationMarkDone: "Als erledigt markieren",
    notificationOk: "OK",
    notificationCancel: "Abbrechen",
    closeAriaLabel: "Schließen",
    leaveConfirmTitle: "Speichern und verlassen?",
    leaveConfirmBody:
      "Dein Fortschritt wird gespeichert. Du kannst dieses Spiel vom Startbildschirm aus fortsetzen.",
    leaveConfirmSave: "Speichern und verlassen",
    leaveConfirmStay: "Im Spiel bleiben",
    leaveConfirmSaveFailed:
      "Spielstand konnte nicht gespeichert werden. Speicherplatz im Browser freigeben und erneut versuchen.",
    notificationEmpty: "Keine Benachrichtigungen im Moment.",
    notificationPageOf: "{current} / {total}",
    notificationPageIndicatorOf: "({current} / {total})",
    notificationSwampTitle: "Sumpf",
    notificationSwampBody: "Dein Clan ist in einen Sumpf eingetreten. Der Boden ist aufgeweicht und vorankommen fällt hier schwerer.",
    notificationFireTitle: "Feuer entdeckt",
    notificationFireBody:
      "Dein Clan hat auf diesem Feld Feuer gefunden—eine seltene Entdeckung beim Erkunden der Karte.",
    notificationFoodDepletionTitle: "Ausgezehrter Boden",
    notificationFoodDepletionBody:
      "Wenn du auf demselben Feld bleibst, sinkt seine Nahrungsproduktion. Zieh weiter und lass das Land sich mit der Zeit erholen.",
    notificationTutorialTurnsTitle: "Dein erster Zug",
    notificationTutorialTurnsBody:
      "Wechsle auf eine angrenzende Kachel oder beende deinen Zug, wenn du bereit bist.",
    notificationTutorialStatsTitle: "Clan-Statistik",
    notificationTutorialStatsBody:
      "Das Panel oben links zeigt Zug, Tageszeit, Jahreszeit, Temperatur, Wetter, Bevölkerung, Nahrung, Wasser und Raubtiere auf deinem Feld. Drücke E oder tippe auf Zug beenden, wenn du sammeln und weitermachen willst.",
    notificationTutorialWinGoalTitle: "So gewinnst du",
    notificationTutorialWinGoalBody:
      "Wachse bis auf 30 Menschen, um zu gewinnen. Fällt die Bevölkerung auf null, ist der Clan verloren.",
    notificationTutorialFoodEconomyTitle: "Nahrung pro Zug",
    notificationTutorialFoodEconomyBody:
      "Beim Zug beenden produziert das Feld Nahrung. Die Bevölkerung isst zuerst—der Rest wird den Vorräten gut- oder abgeschrieben.",
    notificationTutorialTileFoodTitle: "Ein Feld lesen",
    notificationTutorialTileFoodBody:
      "Jedes enthüllte Feld zeigt Gelände und Nahrung pro Zug. Erkunde vor der Ansiedlung—fruchtbare Felder wie Ebenen und Flüsse ernähren länger.",
    notificationTutorialGrowthTitle: "Bevölkerungswachstum",
    notificationTutorialGrowthBody:
      "Bleiben die Vorräte mehrere Züge hoch, wächst die Bevölkerung um eins.",
    notificationTutorialFamineTitle: "Hunger",
    notificationTutorialFamineBody:
      "Hungert der Clan zu lange, verlierst du eine Person. Ziehe auf fruchtbare Felder und baue Reserven auf.",
    notificationTutorialOneMoveTitle: "Bewegung pro Zug",
    notificationTutorialOneMoveBody:
      "Drücke 1–6 oder klicke pro Zug auf ein markiertes Nachbarfeld, oder bleib stehen. Zu langes Bleiben erschöpft das Land.",
    notificationTutorialFoodOverlayTitle: "Nahrung auf der Karte",
    notificationTutorialFoodOverlayBody:
      "Drücke F oder nutze den Korn-Button im HUD, um Nahrung auf enthüllten Feldern zu sehen, ohne jedes einzeln zu öffnen.",
    notificationTutorialLandRecoveryTitle: "Land erholt sich",
    notificationTutorialLandRecoveryBody:
      "Felder, die du verlässt, regenerieren Nahrung mit der Zeit. Bleib in Bewegung, um keinen Ort auszutrinken.",
    notificationTutorialSettingsTitle: "Einstellungen",
    notificationTutorialSettingsBody:
      "Drücke S oder öffne das Zahnrad, um Sprache zu ändern, Soundeffekte anzupassen, den Vollbildmodus umzuschalten, neu zu starten oder zum Titelbildschirm zurückzukehren.",
    notificationTutorialRandomEventsTitle: "Kartenereignisse",
    notificationTutorialRandomEventsBody:
      "Beim Erkunden können unerwartete Ereignisse auftreten. Drücke N oder öffne die Glocke, um zu lesen, was passiert ist.",
    languageLabels: {
      en: "Englisch",
      it: "Italienisch",
      fr: "Französisch",
      es: "Spanisch",
      pt: "Portugiesisch",
      de: "Deutsch",
      zh: "Chinesisch",
      nl: "Niederländisch",
    },
  },
  site: {
    gameTitle: "Dawn of Clans",
    kofiButtonLabel: "Unterstütze mich auf Ko-fi",
    discordLinkLabel: "Discord beitreten",
    landing: {
      primaryDescription:
        "Dawn of Clans ist ein Grand-Strategy-Spiel, in dem du einen prähistorischen Clan durch Überleben, Entdeckung und gesellschaftliche Entwicklung führst.",
      secondaryDescription:
        "Mit einer kleinen nomadischen Gruppe beginnend, schaltest du Technologien durch Erfahrung frei, passt sich an wechselnde Umgebungen an und formst das Erwachen der ersten Zivilisationen.",
      earlyAccessLabel: "Früher Zugang",
      earlyAccessNotice:
        "In früher Entwicklung. Die grundlegende Überlebens-Schleife ist heute spielbar; tiefere Strategiesysteme kommen noch.",
      learnMoreLabel: "Mehr erfahren",
      releaseNoticeText: "Eine neue Version wurde gerade veröffentlicht!",
      playLabel: "Spielen",
      continueLabel: "Fortsetzen",
      savedGameSummary: "Runde {turn}, Bevölkerung {population}",
      resumeModalTitle: "Gespeichertes Spiel",
      newGameLabel: "Neues Spiel",
      loadingLabel: "Lädt...",
      changelogLink: "Änderungsprotokoll",
      careerTeaserFormat:
        "{wins} Siege · schnellster Sieg: {fastest} Züge · meiste Erkundung: {explored}",
      careerViewChronicleLabel: "Siegchronik anzeigen",
      chronicleModalTitle: "Siegchronik",
      chronicleModalCloseLabel: "Schließen",
      chronicleEntryFormat: "{clanName} · {turns} Züge · {date}",
      chronicleClearWinHistoryLabel: "Siegverlauf löschen",
      chronicleClearWinHistoryBody:
        "Entfernt alle gespeicherten Siege auf diesem Gerät. Der aktuelle Spielstand bleibt unverändert.",
      chronicleClearWinHistoryConfirm: "Ja, Verlauf löschen",
      chronicleClearWinHistoryCancel: "Abbrechen",
      settingsGearAriaLabel: "Einstellungen",
      settingsCloseAriaLabel: "Einstellungen schließen",
    },
    about: {
      pageTitle: "Über Dawn of Clans",
      backLinkLabel: "← Zurück zu Dawn of Clans",
      sections: [
        {
          heading: "Überblick",
          body: "Dawn of Clans ist ein Grand-Strategy-Spiel, in dem du einen prähistorischen Clan durch Überleben, Entdeckung und gesellschaftliche Entwicklung führst. Mit einer kleinen nomadischen Gruppe beginnend, schaltest du Technologien durch Erfahrung frei, passt sich an wechselnde Umgebungen an und formst das Erwachen der ersten Zivilisationen.",
        },
        {
          heading: "Dein Clan",
          body: "Zu Beginn einer neuen Partie vergibst du deinem Clan einen Namen und wählst dann einen Siedlungsort auf der Hex-Karte. Nach der ersten Siedlung verfolgst du Zug, Bevölkerung und Nahrung im Statistikpanel. Beende jeden Zug, um deinen Clan zu füttern, und entscheide, ob du vor dem nächsten Zug auf eine angrenzende Kachel wechselst.",
        },
        {
          heading: "Fortschritt",
          body: "Jedes Gelände produziert pro Zug eine andere Menge Nahrung. Wenn deine Vorräte mehrere Züge hoch bleiben, wächst deine Bevölkerung; wenn dein Clan zu lange hungert, verlierst du Menschen. Baue Vorräte auf fruchtbaren Kacheln wie Flüssen und Ebenen auf und wachse bis auf dreißig Menschen, um zu gewinnen. Wenn die Bevölkerung auf null fällt, ist der Clan verloren.",
        },
        {
          heading: "Die Welt",
          body: "Erkunde eine hexagonale Karte, auf der Kacheln zunächst verborgen sind. Klicke, um Wüste, Gebirge, Sumpf, Wald, Ebene und Fluss zu enthüllen. Wähle, wo du deine erste Siedlung errichtest, und wechsle dann pro Zug eine angrenzende Kachel. Fruchtbares Land füttert mehr Menschen; unwirtliches Land erschöpft deine Vorräte schnell.",
        },
        {
          heading: "Status",
          body: "Dawn of Clans ist in früher Entwicklung. Erkundung, Siedlung, rundenbasierte Nahrung und Bevölkerung sowie Sieg oder Niederlage sind heute spielbar. Tiefere Strategie-Systeme werden noch gebaut.",
        },
      ],
      communitySection: {
        heading: "Community",
        body: "Tausche dich mit anderen Spielern aus, gib Feedback und verfolge Entwicklungsupdates auf unserem Discord-Server.",
      },
      supportSection: {
        heading: "Projekt unterstützen",
        body: "Gefällt dir Dawn of Clans? Optionale Spenden auf Ko-fi helfen, die Entwicklung fortzusetzen.",
      },
    },
    changelog: {
      pageTitle: "Änderungsprotokoll",
      backLinkLabel: "← Zurück zu Dawn of Clans",
      loadError: "Änderungsprotokoll konnte nicht geladen werden.",
      emptyState: "Noch keine Versionen veröffentlicht.",
    },
  },
};
